export default {
  scrollBehavior(to, from, savedPosition) {
    // DO NOT scroll to the top when the user clicks "Load More" (page change only)
    if (to.path === from.path && to.query.page !== from.query.page) {
      return false
    }

    // Browser "Back" restores the previous scroll position
    if (savedPosition) {
      return savedPosition
    }

    // Default navigation → scroll to top
    return { top: 0 }
  },
}
